export default ({ COLORS, FONT_SIZES }) => ({
  container: {
    margin: '-22px -22px 0',
    padding: '22px',
    borderBottom: '1px solid #eee'
  },
  title: {
    margin: '0 0 15px',
    color: COLORS.TEXT.MID_GREY.NORMAL,
    ...FONT_SIZES.HEADING_BIG.STYLE
  },
  icon: {
    marginRight: '10px',
    flexShrink: '0'
  },
  holder: {
    display: 'flex',
    alignItems: 'center'
  },
  manualUpdate: {
    marginTop: '20px'
  }
})
